<template>
    <MainLayout>
        <template v-slot:default>
            <!-- end: container -->
            <!-- begin: container -->
            <div class="container-fixed">

                <div class="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div class="flex flex-col justify-center gap-2">
                        <h1 class="text-xl font-semibold leading-none text-gray-900">
                            Supplier:{{ SupplierName }}
                        </h1>
                    </div>
                    <div class="flex items-center gap-2.5">
                        <a class="btn btn-sm btn-light" @click="backtoSupplier">
                            Back To Supplier List
                        </a>
                        <a class="btn btn-sm btn-success" @click="openModal">
                            Add Supplier Product
                        </a>
                    </div>
                </div>
                <Notification ref="notificationRef" />

                <div class="card">
                    <div class="card-header  card-header-bg flex-wrap gap-2">
                        <div class="flex flex-wrap gap-2 lg:gap-5">
                            <div class="flex"><label class="input input-sm"><i class="ki-filled ki-magnifier"></i><input
                                        value="" v-model="searchTerm" type="text" placeholder="Search table"
                                        @input="fetchData"></label>
                            </div>
                        </div>
                    </div>
                    <vue-good-table mode="remote" :server-side="true" :columns="columns" :rows="rows"
                        :total-rows="totalRows" :pagination-options="paginationOptions" :isLoading.sync="isLoading"
                        :search-options="{ enabled: false }" @page-change="onPageChange" @on-page-change="onPageChange"
                        @per-page-change="onPerPageChange" @sort-change="onSortChange">
                        <template #table-row="props">
                            <span v-if="props.column.field === 'actions'">
                                <a @click="handleEdit(props.row)" class="btn btn-sm btn-icon btn-clear btn-light"
                                    href="#">
                                    <i class="ki-filled ki-notepad-edit">
                                    </i>
                                </a>

                                <a @click="handleDelete(props.row)" class="btn btn-sm btn-icon btn-clear btn-light"
                                    href="#">
                                    <i class="ki-filled ki-trash">
                                    </i>
                                </a>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                    </vue-good-table>

                    <Modal :isVisible="showModal" @update:isVisible="showModal = $event">
                        <template v-slot:header>
                            <h2>Add Supplier Product</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="submitForm">

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Code
                                        </label>
                                        <input v-model="form.supplier_product_code"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>
                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Name
                                        </label>
                                        <input v-model="form.supplier_product_name"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Description
                                        </label>
                                        <textarea v-model="form.supplier_product_description"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required></textarea>
                                    </div>
                                </div>

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product cost
                                        </label>
                                        <input v-model="form.supplier_product_cost_price"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>

                                <div class="col-span-1">
                                    <div class="mb-4">
                                        <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                            Product Master <span> {{ indication_master_product }}</span>
                                        </label>

                                        <SearchableSelect v-model="selectedOption" :options="options"
                                            :labelKey="'product_info'" placeholder="Search and select"
                                            @select="handleSelection"
                                            @option-selected="handleOption" />


                                         
                                        <!---
                                        <div style="position: relative"
                                            class="block text-gray-700 text-left text-sm font-bold mb-2">

                                            <input type="text" v-model="searchQuery" ref="product_id"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                @keyup="handleKeyup" placeholder="Type to search..." />
                                            <div class="suggestion-list-container">
                                                <ul v-if="suggestions.length" class="suggestion-list">
                                                    <li v-for="(suggestion, index) in suggestions" :key="index"
                                                        @click="selectSuggestion(suggestion)">
                                                        {{ suggestion.product_code }} - {{ suggestion.product_name }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        --->
                                    </div>
                                </div>

                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button type="submit"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Save</button>
                                </div>
                            </form>
                        </template>
                    </Modal>


                    <Modal :isVisible="showModal2" @update:isVisible="showModal2 = $event">
                        <template v-slot:header>
                            <h2>Edit Supplier Product</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="updateForm">

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Code
                                        </label>
                                        <input v-model="currentItem.supplier_product_code"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>
                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Name
                                        </label>
                                        <input v-model="currentItem.supplier_product_name"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product Description
                                        </label>
                                        <textarea v-model="currentItem.supplier_product_description"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required></textarea>
                                    </div>
                                </div>

                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Product cost
                                        </label>
                                        <input v-model="currentItem.supplier_product_cost_price"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="grid-deparment-name" type="text" required>
                                    </div>
                                </div>

                                <div class="col-span-1">
                                    <div class="mb-4">
                                        <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                            Product Master 
                                        </label>

                                        <SearchableSelect v-model="selectedOption" :options="options"
                                            :labelKey="'product_info'" placeholder="Search and select"
                                             :defaultOption="defaultOption"
                                            @select="handleSelection"
                                            @option-selected="handleOption2" />

                                          

                                       <!-- <SearchableSelect v-model="selectedOption" :options="options"
                                            :defaultOption="defaultOption"
                                            :labelKey="'product_info'" placeholder="Search and select"
                                            @option-selected="handleOption2" />-->

                                        <!--
                                        <div style="position: relative"
                                            class="block text-gray-700 text-left text-sm font-bold mb-2">
                                            
                                            <input type="text" v-model="searchQuery" ref="product_id"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                @keyup="handleKeyup" placeholder="Type to search..." />
                                            <div class="suggestion-list-container">
                                                <ul v-if="suggestions.length" class="suggestion-list">
                                                    <li v-for="(suggestion, index) in suggestions" :key="index"
                                                        @click="selectSuggestion(suggestion)">
                                                        {{ suggestion.product_code }} - {{ suggestion.product_name }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        -->
                                    </div>
                                </div>

                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal2"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button type="submit"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Update</button>
                                </div>
                            </form>
                        </template>
                    </Modal>

                </div>
            </div>
            <!-- end: container -->
        </template>
    </MainLayout>
</template>
<script>
import MainLayout from '@/components/MainLayout.vue'
import apiClient from '@/services/apigen'; // Import your configured Axios instance  
import { ref, watch, onMounted } from 'vue';
import { VueGoodTable } from 'vue-good-table-next';
import Modal from '@/components/utils/Modal.vue'
import 'vue-good-table-next/dist/vue-good-table-next.css';
import Loader from '@/components/utils/loader.vue';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import Notification from '@/components/utils/Notification.vue';
import SearchableSelect from "@/components/utils/Search.vue";


function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

export default {
    name: 'SupplieProductsPage',
    components: {
        MainLayout,
        VueGoodTable,
        Modal,
        Notification,
        SearchableSelect
    },
    created() {
        // Initialize the debounced function
        this.fetchSuggestionsDebounced = debounce(this.fetchSuggestions, 1000);
        this.fetchSuggestions2();
    },
    mounted() {
        // alert(route.params.addNow); 
    },
    setup() {
        const route = useRoute();
        const SupplierName = ref(''); // Define the parent category name as a ref
        const columns = ref([
            { label: '#', field: 'supplier_product_id', type: 'number', sortable: true },
            { label: 'Product Code', field: 'supplier_product_code', sortable: true },
            { label: 'Product Name', field: 'supplier_product_name', sortable: true },
            { label: 'Cost Price', field: 'supplier_product_cost_price', sortable: true },
            { label: 'Product Description ', field: 'supplier_product_description', sortable: true },
            {
                sortable: false,
                label: 'Actions',
                field: 'actions',
                type: 'actions',
                actions: [

                    {
                        label: 'Edit',
                        icon: 'edit',
                        onClick: ""
                    },
                    {
                        label: 'Delete',
                        icon: 'delete',
                        onClick: ""
                    }
                ]
            }
        ]);

        const rows = ref([]);
        const totalRows = ref(0);
        const searchTerm = ref('');
        const currentPage = ref(1);
        const perPage = ref(20);
        const sortField = ref('supplier_product_name');
        const sortType = ref('asc');

        const paginationOptions = ref({
            enabled: true,
            mode: 'pages',
            perPageDropdown: [5, 10, 20],
            perPage: perPage.value,
            totalRecords: totalRows.value,
            currentPage: currentPage.value
        });

        const searchOptions = {
            enabled: true
        };

        // Function to fetch data from the server
        const fetchData = async (page) => {
            const parentCat = route.params.id;

            try {
                const params = {
                    page: page,
                    per_page: perPage.value,
                    sort_field: sortField.value,
                    sort_type: sortType.value,
                    search: searchTerm.value,
                };
                const { data } = await apiClient.get(`/supplier_product/${parentCat}`, { params });
                rows.value = data.data || [];
                totalRows.value = data.total || 0;
                SupplierName.value = data.supplier.supplier_name;

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const onPageChange = ({ currentPage }) => {
            paginationOptions.currentPage = currentPage;
            fetchData(currentPage);
        };

        const onPerPageChange = ({ currentPerPage }) => {
            console.log('Per page changed to:', currentPerPage);
            perPage.value = currentPerPage;
            paginationOptions.value.perPage = currentPerPage;
            fetchData();
        };

        const onSortChange = ([sort]) => {
            console.log('Sort changed to:', sort);
            sortField.value = sort.field;
            sortType.value = sort.type;
            fetchData();
        };
        // Watch for changes to trigger fetchData
        watch([currentPage, perPage, sortField, sortType, searchTerm], fetchData, { immediate: true });
        return {
            columns,
            rows,
            totalRows,
            paginationOptions,
            searchTerm,
            onPageChange,
            onPerPageChange,
            onSortChange,
            route,
            isLoading: false,
            SupplierName

        };
    },

    methods: {

        handleSelection(selectedOption) {
            this.defaultOption = selectedOption; // Update defaultOption when a selection is made
            },
        handleOption(option) {
            
            this.selectedOption = option; // Update selected option from event*/
            
        },

        handleOption2(option){
            this.selectedOption = option; // Update selected option from event*/
        },

        handleKeyup() {
            this.fetchSuggestionsDebounced(); // Call the debounced function
        },

        async fetchSuggestions2() {

            try {
                const response = await apiClient.post(`/product/name_code/keyword2`, {
                    data: { keyword: this.searchQuery2 },
                });

                if (response.data.status == true) {
                    // this.suggestions2 = response.data.data;
                    this.options = response.data.data;
                }
            } catch (error) {
                console.error("Error submitting form:", error.response);
            }
        },


        async fetchSuggestions() {
            //if (this.searchQuery.length > 2) {
            this.indication_master_product = "(Searching...)";
            try {
                const response = await apiClient.post("/product/name_code/keyword", {
                    data: { keyword: this.searchQuery },
                });

                if (response.data.status == true) {
                    this.suggestions = response.data.data;

                    if (response.data.data.length == 0) {
                        this.indication_master_product = "(Product not Found...)";
                        this.form.product_id = 0;
                        this.currentItem.product_id = 0;
                    } else {
                        this.indication_master_product = "";
                    }
                }
            } catch (error) {
                console.error("Error submitting form:", error.response);
            }
            //} else {
            // this.suggestions = []; // Clear suggestions if input is less than 3 characters
            //}
        },
        selectSuggestion(suggestion) {

            this.searchQuery = suggestion.product_name; // Populate the input with the selected suggestion
            this.productSearch = suggestion;
            if (this.showModal == true) {
                this.form.product_id = suggestion.product_id;
            } else {
                this.currentItem.product_id = suggestion.product_id;
            }
            // 
            this.suggestions = []; // Clear suggestions list
        },
        handleViewProvince(data) {
            const country_id = this.$route.params.id; // Accessing route params via 'this'
            window.location = `/settings/city/${country_id}/` + data.province_id;
        },
        backtoSupplier() {
            this.$router.push({ name: 'SupplierListPage' }); // Redirect on success
        },
        handleEdit(data) {
            this.showInfo(data.supplier_product_id);
        },
        handleDelete(data) {

            let supplier_product_id = data.supplier_product_id;

            Swal.fire({
                title: 'Are you sure do you want to delete?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteData(supplier_product_id);
                }
            });

        },
        openModal() {
            this.showModal = true;
            this.searchQuery = "";
            this.productSearch = [];
            this.indication_master_product = "";
            this.product_id = 0;
        },
        closeModal() {
            this.showModal = false;
        },
        closeModal2() {
            this.showModal2 = false;
        },
        async showInfo(province_id) {

            //let loader = this.$loading.show();
            this.showModal2 = true; // Show the modal
       

            let id = province_id;
            const response = await apiClient.get(`/supplier_producct/${id}/get_info`);
         
            this.currentItem = response.data.data; // Store the fetched data
   


            if(this.currentItem.product_code!=null){
                this.searchQuery = this.currentItem.product_code +" - "+this.currentItem.product_name;
                this.defaultOption= {'name': this.searchQuery }; // Example default option
            }    

            //this.searchQuery = 
            //this.indication_master_product = "";
            // Optionally, you might want to update the state or show the result in the UI


        },
        async deleteData(id) {
            let loader = this.$loading.show();
            const parentCat = this.$route.params.id; // Accessing route params via 'this'
            try {
                const response = await apiClient.delete(`/supplier_producct/${parentCat}/delete`, { data: { id: id } });
                if (response.data.status == true) { // or check for other success c
                    this.$refs.notificationRef.show('Successfully Deleted', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);
                loader.hide();
            }
        },
        async updateForm() {
            const parentCat = this.$route.params.id; // Accessing route params via 'this'

            this.currentItem.product_id = this.selectedOption.product_id

            try {

                const response = await apiClient.put(`/supplier_producct/${parentCat}/update`, this.currentItem);
                if (response.data.status == true) { // or check for other success 
                    this.showModal2 = false;
                    this.$refs.notificationRef.show('Successfully Updated', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error updatting form:', error.response);

            }
        },
        async submitForm() {
            const parentCat = this.$route.params.id; // Accessing route params via 'this'

            this.form.product_id = this.selectedOption.product_id

            try {
                const response = await apiClient.post(`/supplier_producct/${parentCat}/save`, this.form);

                if (response.data.status == true) {
                    this.showModal = false;
                    this.$refs.notificationRef.show('Successfully Saved', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        }

    },
    data() {
        return {
            showModal: false,
            form: {
                //province_name: ''
                product_id: 0
            },
            showModal2: false,
            currentItem: '',
            suggestions: [],
            searchQuery: "",
            productSearch: [],
            indication_master_product: "",
            options: [],
            selectedOption: [], // Stores the selected option
            defaultOption:{'name':''}
        };
    },


}
</script>


<style></style>